export default __webpack_public_path__ + "static/media/reward1_detail_7-1.819a8541.png";